(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vivazz-campaign-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'vivazz-campaign-badge';
  if (customElements.get(tag)) return;
  const nodes = new Set();
  const indexes = new Map();
  const styles = new Set(['relampago', 'presentes', 'queima', 'data']);
  let timer;
  const safeCandidates = (items) => Array.isArray(items) ? items.filter(c => c && typeof c.text === 'string' && c.text.trim() && styles.has(c.style) && Number.isFinite(c.start) && Number.isFinite(c.end) && c.end > c.start && Number.isFinite(c.priority)) : [];
  const readRegistry = () => {
    try { return safeCandidates(JSON.parse(document.getElementById('vivazz-campaign-registry')?.textContent || '[]')); }
    catch { return []; }
  };
  const readIndex = (path) => {
    if (indexes.has(path)) return indexes.get(path);
    const pending = (async () => {
      const ids = new Set();
      let url = new URL(path, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid campaign collection');
      const seen = new Set();
      while (url) {
        url.searchParams.set('section_id', 'vivazz-campaign-index');
        const key = url.href;
        if (seen.has(key) || seen.size >= 100) throw new Error('Invalid campaign pagination');
        seen.add(key);
        const response = await fetch(key, {credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) throw new Error('Campaign index unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const payload = JSON.parse(doc.querySelector('[data-vivazz-campaign-index]')?.textContent || 'null');
        if (!payload || !Array.isArray(payload.ids)) throw new Error('Invalid campaign index');
        payload.ids.forEach(id => ids.add(String(id)));
        url = payload.next ? new URL(payload.next, url) : null;
        if (url && url.origin !== location.origin) throw new Error('Invalid campaign page');
      }
      return ids;
    })();
    indexes.set(path, pending);
    pending.catch(() => indexes.delete(path));
    return pending;
  };
  const refresh = () => {
    clearTimeout(timer);
    const now = Date.now();
    let nextDelay = 60000;
    nodes.forEach(node => {
      node.updateBadge(now);
      node.candidates.forEach(c => {
        if (c.start > now) nextDelay = Math.min(nextDelay, c.start - now);
        if (c.end > now) nextDelay = Math.min(nextDelay, c.end - now);
      });
    });
    if (nodes.size) timer = setTimeout(refresh, Math.max(50, nextDelay + 20));
  };
  class VivazzCampaignBadge extends HTMLElement {
    connectedCallback() {
      this.candidates = [];
      this.label = this.querySelector('.vivazz-campaign-badge__label');
      try { this.candidates = safeCandidates(JSON.parse(this.dataset.campaigns || '[]')); } catch {}
      nodes.add(this);
      if (this.dataset.lookup === 'true') this.resolveMembership();
      refresh();
    }
    disconnectedCallback() {
      nodes.delete(this);
      if (!nodes.size) clearTimeout(timer);
    }
    async resolveMembership() {
      this.hidden = true;
      const campaigns = readRegistry().filter(c => c.end > Date.now());
      const matches = await Promise.all(campaigns.map(async c => {
        try { return (await readIndex(c.collectionUrl)).has(this.dataset.productId) ? c : null; }
        catch { return null; }
      }));
      if (!this.isConnected) return;
      this.candidates = matches.filter(Boolean);
      if (!this.candidates.length) nodes.delete(this);
      refresh();
    }
    updateBadge(now) {
      const winner = this.candidates.filter(c => now >= c.start && now < c.end).sort((a, b) => b.priority - a.priority)[0];
      this.hidden = !winner;
      if (!winner) return;
      if (!this.label) {
        this.label = document.createElement('span');
        this.appendChild(this.label);
      }
      this.label.className = 'vivazz-campaign-badge__label vivazz-campaign-badge__label--' + winner.style;
      this.label.textContent = winner.text;
    }
  }
  customElements.define(tag, VivazzCampaignBadge);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
})();
  } catch(e) { console.error(e); }
})();

})();
